<script>
    export let images = [];

    let leftImages = images.filter((_, i) => i % 2 === 0);
    let rightImages = images.filter((_, i) => i % 2 === 1);
</script>

<div class="image-row side-by-side">
    {#each images as image}
        <div class="saaltext-image-wrapper">
            <img src={image.src} alt={image.caption} class="saaltext-image" />
            <div class="text-s saaltext-image-caption">
                {image.caption}
            </div>
        </div>
    {/each}
</div>
<div class="image-row">
    <div class="image-column left-column">
        {#each leftImages as image}
            <div class="saaltext-image-wrapper">
                <img
                    src={image.src}
                    alt={image.caption}
                    class="saaltext-image"
                />
                <div class="text-s saaltext-image-caption">
                    {image.caption}
                </div>
            </div>
        {/each}
    </div>
    <div class="image-column right-column">
        {#each rightImages as image}
            <div class="saaltext-image-wrapper">
                <img
                    src={image.src}
                    alt={image.caption}
                    class="saaltext-image"
                />
                <div class="text-s saaltext-image-caption">
                    {image.caption}
                </div>
            </div>
        {/each}
    </div>
</div>

<style>
    .image-row {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        margin: 0 0;
    }

    .image-column {
        display: flex;
        flex-direction: column;
        justify-content: start;
        margin: 8px 0;
    }

    .left-column {
        padding-right: 8px;
    }

    .right-column {
        padding-left: 8px;
    }

    .saaltext-image {
        width: 100%;
        height: auto;
    }

    .saaltext-image-wrapper {
        width: 156px;
        height: auto;
        margin-bottom: 16px;
    }

    .side-by-side {
        display: none;
    }

    @media only screen and (min-width: 1440px) {
        .side-by-side {
            display: block;
        }

        .image-row {
            display: grid;
            grid-auto-columns: 0.4fr;
            grid-auto-flow: column;
            gap: 48px;
            align-items: start;
            margin: 0 32px;
        }

        .image-column {
            display: none;
        }

        .saaltext-image-wrapper {
            width: 100%;
        }

        .saaltext-image-caption {
            font-weight: 400;
            font-size: 14px;
            line-height: 112%;
            letter-spacing: -0.02em;
        }
    }
</style>
